/* eslint-disable no-restricted-imports */
import { Magic as MagicAction } from './actions/Magic';
var actions = {
    Magic: MagicAction,
};
var Magic = {
    actions: actions,
};
export { Magic };
